export const GET_CLIENT_VEHICLES_INFO = "GET_CLIENT_VEHICLES_INFO";
export const GET_CLIENT_VEHICLES_INFO_SUCCESS = "GET_CLIENT_VEHICLES_INFO_SUCCESS";
export const GET_CLIENT_VEHICLES_INFO_ERROR = "GET_CLIENT_VEHICLES_INFO_ERROR";

export const SET_CLIENT_VEHICLES_INFO_FILTERS = "SET_CLIENT_VEHICLES_INFO_FILTERS";